import { render, staticRenderFns } from "./CommunicationSMSForm.vue?vue&type=template&id=1affa6a1&"
import script from "./CommunicationSMSForm.vue?vue&type=script&lang=js&"
export * from "./CommunicationSMSForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports